// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hr-avatar-page-wrap .drop-file-wrap {
    width: 100%;
}

.hr-avatar-page-wrap .desktop-footer-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 27px;
    gap: 17px;
}

.hr-avatar-page-wrap .chat-button-wrap {
    background: white;
    height: max-content;
    border-radius: 100px;
    padding: 20px;
    position: relative;
}

.hr-avatar-page-wrap .chat-button-wrap .message-count {
    position: absolute;
    top: -8px;
    background: #ffb800;
    right: -14px;
    padding: 6px 13px;
    border-radius: 100px;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    color: #000000;
}

.hr-avatar-page-wrap .dropFileText {
    font-size: 22px;
    font-weight: 700;
    line-height: 75px;
    letter-spacing: -0.02em;
    text-align: center;
}

.hr-avatar-page-wrap .drop-file-title {
    width: 100%;
    margin: auto;
    font-size: 22px;
    font-weight: 700;
    line-height: 75px;
    letter-spacing: -0.02em;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-self: center;
    align-items: center;
}

.hr-avatar-page-wrap .drop-file-title img {
    width: 44px;
    height: 44px;
}

.hr-avatar-page-wrap .left-content-resize {
    height: 40vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
}

.hr-avatar-page-wrap .left-content-resize .caller-img {
    width: 100%;
    height: 100%;
}

.hr-avatar-page-wrap .left-content-resize .bottom-title {
    font-size: 16px !important;
}

.hr-avatar-page-wrap .right-content-resize .bottom-title {
    padding: 17px 20px;
    /* height: unset !important; */
    font-size: 16px !important;
}

.hr-avatar-page-wrap .right-content-resize {
    height: 40vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 40vw;
}

.hr-avatar-page-wrap .icon-button {
    background-color: transparent;
    border: none;
}

.hr-avatar-page-wrap .chat-container {
    background-color: white;
    height: 40vw;
    margin-left: 16px;
}

@media (min-width: 1450px) {
    .hr-avatar-page-wrap .trainer-mode-wrap .left-img-wrap .bottom-icon-wrap {
        height: 70px !important;
    }

    .hr-avatar-page-wrap .trainer-mode-wrap .right-img-wrap .bottom-title {
        height: 70px !important;
    }

    .hr-avatar-page-wrap .desktop-footer-wrap {
        margin-top: 15px;
    }

    .hr-avatar-page-wrap .trainer-mode-bottom-content .left-img-wrap .icon-img {
        width: 30px;
        height: 30px;
    }

    .hr-avatar-page-wrap .chat-button-wrap {
        padding: 10px;
    }

    .hr-avatar-page-wrap .trainer-mode-bottom-content .left-img-wrap .caller-img {
        width: 350px;
    }

    .hr-avatar-page-wrap .trainer-mode-bottom-content .right-img-wrap .caller-img {
        width: 350px;
    }

    .hr-avatar-page-wrap .dropFileText {
        line-height: 45px;
        font-size: 18px;
    }

    .hr-avatar-page-wrap .left-content-resize .caller-img {
        width: 400px;
        height: 400px;
    }

    .hr-avatar-page-wrap .left-content-resize {
        height: 24vw;
    }

    .hr-avatar-page-wrap .right-content-resize {
        height: 24vw;
    }

    .hr-avatar-page-wrap .chat-container {
        height: 24vw;
    }

    .hr-avatar-page-wrap .right-content-resize .caller-img {
        width: 400px;
        height: 400px;
    }

    .hr-avatar-page-wrap .trainer-mode-bottom-content .left-img-wrap .bottom-icon-wrap {
        height: 40px;
    }

    .hr-avatar-page-wrap .trainer-mode-bottom-content .right-img-wrap .bottom-title {
        height: 40px;
    }
}

@media screen and (max-width: 768px) {
    .hr-avatar-page-wrap .desktop-chat {
        display: none;
    }

    .hr-avatar-page-wrap .desktop-footer-wrap {
        display: none;
    }

    .mobile-chat-wrap .MuiPaper-root {
        height: calc(90% - 56px) !important;
    }

    .chat-mob-screen .chat-container {
        border: none;
        box-shadow: unset;
    }

    .chat-mob-screen .chat-container .chat-header {
        display: block;
    }

    .chat-mob-screen .chat-container .chat-header .close-icon {
        display: none;
    }

    .chat-mob-screen .chat-container .chat-header .title {
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        line-height: 27px;
    }

    .chat-mob-screen .chat-container .chat-input {
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 13px 20px 45px;
    }

    .mobile-chat-wrap .drawer-content-heading {
        top: -25px !important;
    }

    .mobile-chat-wrap .drawer-content-wrap {
        margin-top: 0px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/InterviewSimulatorPages/HrSimulatorPages/HrAvatarMode.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B,6BAA6B;IACjC;AACJ","sourcesContent":[".hr-avatar-page-wrap .drop-file-wrap {\n    width: 100%;\n}\n\n.hr-avatar-page-wrap .desktop-footer-wrap {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 27px;\n    gap: 17px;\n}\n\n.hr-avatar-page-wrap .chat-button-wrap {\n    background: white;\n    height: max-content;\n    border-radius: 100px;\n    padding: 20px;\n    position: relative;\n}\n\n.hr-avatar-page-wrap .chat-button-wrap .message-count {\n    position: absolute;\n    top: -8px;\n    background: #ffb800;\n    right: -14px;\n    padding: 6px 13px;\n    border-radius: 100px;\n    font-size: 16px;\n    font-weight: 600;\n    text-align: left;\n    color: #000000;\n}\n\n.hr-avatar-page-wrap .dropFileText {\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 75px;\n    letter-spacing: -0.02em;\n    text-align: center;\n}\n\n.hr-avatar-page-wrap .drop-file-title {\n    width: 100%;\n    margin: auto;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 75px;\n    letter-spacing: -0.02em;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-self: center;\n    align-items: center;\n}\n\n.hr-avatar-page-wrap .drop-file-title img {\n    width: 44px;\n    height: 44px;\n}\n\n.hr-avatar-page-wrap .left-content-resize {\n    height: 40vw;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    overflow: hidden;\n}\n\n.hr-avatar-page-wrap .left-content-resize .caller-img {\n    width: 100%;\n    height: 100%;\n}\n\n.hr-avatar-page-wrap .left-content-resize .bottom-title {\n    font-size: 16px !important;\n}\n\n.hr-avatar-page-wrap .right-content-resize .bottom-title {\n    padding: 17px 20px;\n    /* height: unset !important; */\n    font-size: 16px !important;\n}\n\n.hr-avatar-page-wrap .right-content-resize {\n    height: 40vw;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    height: 40vw;\n}\n\n.hr-avatar-page-wrap .icon-button {\n    background-color: transparent;\n    border: none;\n}\n\n.hr-avatar-page-wrap .chat-container {\n    background-color: white;\n    height: 40vw;\n    margin-left: 16px;\n}\n\n@media (min-width: 1450px) {\n    .hr-avatar-page-wrap .trainer-mode-wrap .left-img-wrap .bottom-icon-wrap {\n        height: 70px !important;\n    }\n\n    .hr-avatar-page-wrap .trainer-mode-wrap .right-img-wrap .bottom-title {\n        height: 70px !important;\n    }\n\n    .hr-avatar-page-wrap .desktop-footer-wrap {\n        margin-top: 15px;\n    }\n\n    .hr-avatar-page-wrap .trainer-mode-bottom-content .left-img-wrap .icon-img {\n        width: 30px;\n        height: 30px;\n    }\n\n    .hr-avatar-page-wrap .chat-button-wrap {\n        padding: 10px;\n    }\n\n    .hr-avatar-page-wrap .trainer-mode-bottom-content .left-img-wrap .caller-img {\n        width: 350px;\n    }\n\n    .hr-avatar-page-wrap .trainer-mode-bottom-content .right-img-wrap .caller-img {\n        width: 350px;\n    }\n\n    .hr-avatar-page-wrap .dropFileText {\n        line-height: 45px;\n        font-size: 18px;\n    }\n\n    .hr-avatar-page-wrap .left-content-resize .caller-img {\n        width: 400px;\n        height: 400px;\n    }\n\n    .hr-avatar-page-wrap .left-content-resize {\n        height: 24vw;\n    }\n\n    .hr-avatar-page-wrap .right-content-resize {\n        height: 24vw;\n    }\n\n    .hr-avatar-page-wrap .chat-container {\n        height: 24vw;\n    }\n\n    .hr-avatar-page-wrap .right-content-resize .caller-img {\n        width: 400px;\n        height: 400px;\n    }\n\n    .hr-avatar-page-wrap .trainer-mode-bottom-content .left-img-wrap .bottom-icon-wrap {\n        height: 40px;\n    }\n\n    .hr-avatar-page-wrap .trainer-mode-bottom-content .right-img-wrap .bottom-title {\n        height: 40px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .hr-avatar-page-wrap .desktop-chat {\n        display: none;\n    }\n\n    .hr-avatar-page-wrap .desktop-footer-wrap {\n        display: none;\n    }\n\n    .mobile-chat-wrap .MuiPaper-root {\n        height: calc(90% - 56px) !important;\n    }\n\n    .chat-mob-screen .chat-container {\n        border: none;\n        box-shadow: unset;\n    }\n\n    .chat-mob-screen .chat-container .chat-header {\n        display: block;\n    }\n\n    .chat-mob-screen .chat-container .chat-header .close-icon {\n        display: none;\n    }\n\n    .chat-mob-screen .chat-container .chat-header .title {\n        text-align: center;\n        font-size: 16px;\n        font-weight: 700;\n        line-height: 27px;\n    }\n\n    .chat-mob-screen .chat-container .chat-input {\n        position: fixed;\n        bottom: 0;\n        width: 100%;\n        padding: 13px 20px 45px;\n    }\n\n    .mobile-chat-wrap .drawer-content-heading {\n        top: -25px !important;\n    }\n\n    .mobile-chat-wrap .drawer-content-wrap {\n        margin-top: 0px !important;\n        padding-left: 0px !important;\n        padding-right: 0px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
